import { FeatureFlag } from '../FeatureFlag';

export const enableAdminTradingOrderManagementDebug = new FeatureFlag({
    key: 'enable-admin-trading-order-management-debug',
    defaultValue: false,
});
